const host = 'https://wyc-fe-static.yun-sk.com/static/yunsk/'
const b2bHost = 'https://wyc-fe-static.yun-sk.com/static/b2b/'
export default {
    logoWyc: `${host}yunsk-wyc.png`,
    logoHello: `${host}hello.png`,
    loginBgWyc: `${host}wyc-login-bg.png`,
    bannerWyc: `${host}homebanner_wyc.png`,
    bannerWxwyc: `${host}homebanner_wxwyc.png`,
    bannerDzsy: `${host}homebanner_dzsy.png`,
    step_1: `${host}step_1.png`,
    step_2: `${host}step_2.png`,
    step_3: `${host}step_3.png`,
    stepIcon_1: `${host}step_icon_1.png`,
    stepIcon_2: `${host}step_icon_2.png`,
    stepIcon_3: `${host}step_icon_3.png`,
    wycWxcode: `${host}wyc-wxcode.jpg`,
    iconRightDark: `${host}icon-right-dark.png`,
    iconRightLight: `${host}icon-right-light.png`,
    icondbArrow: `${host}icon-dbarrow.png`,
    wycBg: `${host}wyc-bg.png`,
    iconPdf: `${b2bHost}icon_pdf.png`,
    bannerQuality: `${host}homebanner_quality.png`
}


// WEBPACK FOOTER //
// ./src/config/images.js